import ConfirmModal from '@components/modal/ConfirmModal';
import usePrevious from 'lib/src/hooks/usePrevious';
import { useEffect } from 'react';
import { SuperAdminUser } from 'src/types/shared/SuperAdminUser';
import useDeleteSuperAdmin from './hooks/useDeleteSuperAdmin';

const DeleteSuperAdminModal: React.FC<DeleteSuperAdminProps> = ({ user, closeModal }) => {
    const { deleteUser, isPosting, error, deleteSuccess } = useDeleteSuperAdmin(user.id);
    const prevSuccess = usePrevious(deleteSuccess);

    useEffect(() => {
        if (!prevSuccess && deleteSuccess) closeModal();
    }, [deleteSuccess, prevSuccess, closeModal]);

    return (
        <ConfirmModal
            title="Delete super admin"
            description={`Are you sure you want to delete '${user.firstName} ${user.lastName}'?`}
            closeModal={closeModal}
            handleSubmit={deleteUser}
            isPosting={isPosting}
            error={error}
        />
    );
};

interface DeleteSuperAdminProps {
    user: SuperAdminUser;
    closeModal: () => void;
}

export default DeleteSuperAdminModal;
